module.exports = __webpack_public_path__ + "img/wide.40d00b88.jpg";